<script setup lang="ts">
import { computed } from "vue";

import { useUnderwriters } from "@/queries/submissions";

const { data: underwriters } = useUnderwriters();

const props = withDefaults(defineProps<{
	underwriterValue?: string | undefined | null;
	disabled?: boolean;
	valueKey?: "id" | "email";
	clearable?: boolean;
}>(), {
	underwriterValue: undefined,
	disabled: false,
	valueKey: "id",
	clearable: false,
});

const underwriterSelectOpts = computed(() => {
	return underwriters.value?.map((u) => ({
		label: u.name ?? "",
		value: u[props.valueKey],
		avatar: {
			alt: u.name ?? "",
			src: u.avatar ?? "",
		},
	}));
});

const emit = defineEmits<{
	(e: "update:underwriterValue", value: string | undefined): void;
}>();

const selectedUnderwriter = computed({
	get: () => underwriterSelectOpts.value?.find((opt) => opt.value === props.underwriterValue),
	set: (newVal) => emit("update:underwriterValue", newVal?.value),
});
</script>
<template>
  <USelectMenu
    v-model="selectedUnderwriter"
    :avatar="selectedUnderwriter?.avatar"
    :items="underwriterSelectOpts"
    :disabled="props.disabled"
    :clear="props.clearable"
    option-attribute="label"
    placeholder="Select an underwriter"
    class="w-full"
  />
</template>

